import { render, staticRenderFns } from "./ItemAddressItem.vue?vue&type=template&id=a461b870&scoped=true&"
import script from "./ItemAddressItem.vue?vue&type=script&lang=js&"
export * from "./ItemAddressItem.vue?vue&type=script&lang=js&"
import style0 from "./ItemAddressItem.vue?vue&type=style&index=0&id=a461b870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a461b870",
  null
  
)

export default component.exports